<span [ngSwitch]="status">
    <span class="badge bg-danger" *ngSwitchCase="'OUT_OF_STOCK'">{{'stockStatusValue.OUT_OF_STOCK' | translate}}</span>
    <span class="badge bg-warning" *ngSwitchCase="'LOW'">{{'stockStatusValue.LOW' | translate}}</span>
    <span class="badge bg-success" *ngSwitchCase="'SUFFICIENT'">{{'stockStatusValue.SUFFICIENT' | translate}}</span>
    <span class="badge bg-secondary" *ngSwitchDefault>{{ status }}</span>
</span>